import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { BrandMark } from "@/components/cards";
import { Button, Spinner, WaveBackdrop } from "@/components/kit";
import { useApp } from "@/store";

export default function Welcome() {
  const { ready, mode, onboarded, continueAsGuest } = useApp();
  const navigate = useNavigate();
  if (!ready) return <div className="flex min-h-screen items-center justify-center bg-navy"><Spinner /></div>;
  if (mode) return <Navigate to={onboarded ? "/home" : "/questionnaire"} replace />;

  return (
    <div data-testid="welcome-screen" className="relative flex min-h-[100dvh] flex-col overflow-hidden bg-navy">
      <img src="/welcome.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(16,39,72,0.05) 0%, rgba(16,39,72,0.35) 45%, rgba(16,39,72,0.92) 85%)" }} />
      <div className="absolute inset-0 hidden md:block" style={{ background: "linear-gradient(90deg, rgba(16,39,72,0.85) 0%, rgba(16,39,72,0.2) 60%, rgba(16,39,72,0) 100%)" }} />
      <WaveBackdrop tone="dark" />
      <div className="relative z-10 mx-auto flex w-full max-w-6xl items-start px-6 pt-6 md:px-10">
        <BrandMark testId="welcome-wordmark" height={34} className="font-display text-[26px] tracking-[8px] text-white" />
        <span className="ml-0.5 mt-0.5 font-body-semi text-[10px] text-white">®</span>
      </div>
      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col justify-end px-6 pb-8 md:justify-center md:px-10">
        <div className="max-w-md">
          <p className="animate-fade-up mb-2 font-body-bold text-xs tracking-[3px] text-sky" style={{ animationDelay: "100ms" }}>BREEZ AI</p>
          <h1 data-testid="welcome-headline" className="animate-fade-up font-display text-[44px] leading-[46px] tracking-[-0.5px] text-white md:text-[64px] md:leading-[64px]" style={{ animationDelay: "220ms" }}>
            FIND THE STYLE THAT FITS YOU.
          </h1>
          <p className="animate-fade-up mt-3 max-w-[360px] font-body text-[15px] leading-[22px] text-soft" style={{ animationDelay: "340ms" }}>
            Discover your hair type, explore hairstyles and find the right products for your routine.
          </p>
          <div className="animate-fade-up mt-6 flex flex-col gap-3" style={{ animationDelay: "460ms" }}>
            <Button testId="get-started-button" title="Get Started" variant="secondary" onClick={() => navigate("/auth?mode=register")} />
            <Button
              testId="explore-as-guest-button"
              title="Explore as Guest"
              variant="glass"
              onClick={async () => {
                await continueAsGuest();
                navigate("/questionnaire", { replace: true });
              }}
            />
            <button type="button" data-testid="sign-in-link" onClick={() => navigate("/auth?mode=login")} className="focus-ring rounded-md py-2 text-center font-body text-sm text-soft hover:text-white">
              Already have an account? <span className="font-body-bold text-white">Sign in</span>
            </button>
          </div>
          <p className="mt-3 text-center font-body-bold text-[10px] tracking-[2px] text-soft">YOUR HAIR. YOUR STYLE. YOUR BREEZ.</p>
        </div>
      </div>
    </div>
  );
}
